import { Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

@Component({
  selector: 'app-exam-navigation',
  templateUrl: './exam-navigation.component.html',
  styleUrls: ['./exam-navigation.component.scss']
})

export class ExamNavigationComponent implements OnInit, OnDestroy {

  questions: any[] = [];
  timeLeft: number = 0;
  answeredQuestionsCount: number = 0;
  questionStatus: string[] = [];
  private timer: any;
  examStarted: boolean = false;
  examCompleted: boolean = false;
  answers : any ;

  constructor(
    public dialogRef: MatDialogRef<ExamNavigationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.questions = data.questions;
    this.timeLeft = data.timeLeft;
    this.answeredQuestionsCount = data.answeredQuestionsCount;
    this.questionStatus = data.questionStatus;
    this.answers = data.answers;
  }

  ngOnInit() {
    this.startExamTimer();
  }

  ngOnDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  closeMenu(): void {
    this.dialogRef.close();
  }

  jumpToQuestion(index: number): void {
    this.dialogRef.close(index);
  }

  getStatusColor(status: string): string {
    switch (status) {
      case 'not-visited': return 'bg-gray-200';
      case 'current': return 'bg-blue-500 text-white';
      case 'answered': return 'bg-green-500 text-white';
      case 'skipped': return 'bg-yellow-500 text-white';
      default: return 'bg-gray-200';
    }
  }

  formatTime(seconds: number): string {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
  }

  get answeredQuestionCount(): number {
    return Object.keys(this.answers).length;
  }

  get progressWidth(): string {
    return `${(this.answeredQuestionsCount / this.questions.length) * 100}%`;
  }

  startExamTimer() {
    this.timer = setInterval(() => {
      this.timeLeft--;
      if (this.timeLeft <= 0) {
        clearInterval(this.timer);
        this.handleSubmit();
      }
    }, 1000);
  }

  handleSubmit() {
    this.examCompleted = true;
    clearInterval(this.timer);
    console.log('Exam submitted');
    this.dialogRef.close();
  }
}
